import { SearchableSelect } from "../../../common/components";

export default function SubmitReflectionModal({
  open,
  onClose,
  submitConfig,
  selectedWeekId,
  setSelectedWeekId,
  submittedWeeks,
  promptDrafts,
  setPromptValue,
  visibility,
  setVisibility,
  onConfirm,
}) {
  if (!open) return null;

  const weekOptions = (submitConfig.weeks || []).map((w) => ({
    value: w.id,
    label: `${w.label}${submittedWeeks[w.id] ? " (submitted)" : ""}`,
  }));

  const weekDrafts = promptDrafts[selectedWeekId] || {};
  const selectedWeek = submitConfig.weeks.find((w) => w.id === selectedWeekId);
  const isSubmitted = selectedWeekId ? !!submittedWeeks[selectedWeekId] : false;

  return (
    <div className="rtv2-modal-scrim" onClick={onClose}>
      <div className="rtv2-modal" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <div className="rtv2-modal-head">
          <h3>Submit weekly reflection <em>— for review</em></h3>
          <button type="button" onClick={onClose}>✕</button>
        </div>

        <div className="rtv2-modal-body">
          <div className="rtv2-modal-row">
            <label>Week</label>
            <SearchableSelect options={weekOptions} value={selectedWeekId} onChange={setSelectedWeekId} placeholder="Pick a completed week" />
          </div>

          {!selectedWeek ? (
            <div className="rtv2-state">No week selected.</div>
          ) : (
            <>
              <div className="rtv2-subhead">{selectedWeek.label}{isSubmitted ? " · already submitted" : ""}</div>
              <div className="rtv2-prompts">
                {(submitConfig.promptDefs || []).map((p) => {
                  const value = weekDrafts[p.key] || "";
                  const max = p.maxChars || 600;
                  return (
                    <div className="rtv2-prompt" key={p.key}>
                      <div className="tag">{p.label}</div>
                      <textarea
                        value={value}
                        maxLength={max}
                        onChange={(e) => setPromptValue(p.key, e.target.value)}
                        placeholder="Write your reflection..."
                        disabled={isSubmitted}
                      />
                      <span className="ct">{value.length}/{max}</span>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>

        <div className="rtv2-modal-foot">
          <div className="rtv2-visibility">
            <span>Visibility</span>
            <select value={visibility} onChange={(e) => setVisibility(e.target.value)} disabled={isSubmitted}>
              {submitConfig.visibilityOptions.map((o) => (
                <option value={o.value} key={o.value}>{o.label}</option>
              ))}
            </select>
          </div>
          <span className="spacer" />
          <button className="v2drw-btn-cancel" type="button" onClick={onClose}>Cancel</button>
          <button className="v2drw-btn-save" type="button" onClick={onConfirm} disabled={!selectedWeekId || isSubmitted}>Submit reflection</button>
        </div>

        <div className="rtv2-modal-meta">Locks scores · prompts editable until reviewer signs off</div>
      </div>
    </div>
  );
}
